export default "__VITE_ASSET__Ceq6sqZR__"